import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { CalculationSettingsModel, RNAVModel } from '../models/configuration';
import { coverageAssessmentToolDTOModal, coverageDTO, coverageDTOModal } from '../models/coverageDTO';
import { NavaidDTOCalculation, NavaidModel, NavaidSitingToolModel } from '../models/navaid';
import { PerformanceDTO, PerformanceDTOModel } from '../models/performanceDTO';
import { CalculationsService } from './calculations.service';
import { ConfigurationService } from './configuration.service';
import { MapService } from './map.service';
import { ModalConfirmationService } from './modal-confirmation.service';
import { ModalControlService } from './modal-control.service';
import { NavaidsCoChannelsService } from './navaids-co-channels.service';
import { PointsService } from './points.service';
import { UtilsService } from './utils.service';
import { ValidationModalService } from './validation-modal.service';
import { PropagationType, RangeLimitation, CalculationType, CoverageAlgorithmType, NavaidTypes, FeatureType, AntennaTypes } from 'src/app/models/EnumTypes';
import { cloneDeep } from 'lodash';
import { PendingCalculation, PendingCalculationType } from '../models/pendingCalculation';
import { Geometry } from 'ol/geom';
import { PerformanceAnalysisDTO } from '../models/performanceAnalysisDTO';
import { ProcedureControlService } from './procedure-control.service';
import { NavaidSitingToolComponent } from '../popup/calculations/navaid-siting-tool/navaid-siting-tool.component';
import { Draw } from 'ol/interaction';
import olMap from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import {GritApiService} from "./grit/grit.api.service";
import {Coordinate} from "ol/coordinate";
import {GritFeature} from "../models/grit/grit.feature";
import {DeviceModel} from "../models/grit/grit.device-model";
import {ImpactAssessmentDTO} from "../models/grit/grit.calculation-dto";
import { NavaidAntennaModelAssociationComponent } from '../popup/navaid-antenna-model-association/navaid-antenna-model-association.component';

@Injectable({
  providedIn: 'root'
})
export class CalculationsControlService {



  draw: Draw;

  public coverageDTO : coverageDTO;
  public coverageDTOModal : coverageDTOModal;
  public coverageAssessmentDTOModal : coverageAssessmentToolDTOModal;

  public performanceDTOModel: PerformanceDTOModel;
  public performanceDTO : PerformanceDTO;

  constructor(
    public configurationService : ConfigurationService,
    private pointsController : PointsService,
    public mapService : MapService,
    private calculationService : CalculationsService,
    private utilsService: UtilsService,
    private validationModalService: ValidationModalService,
    private modalConfirmation: ModalConfirmationService,
    private modalService: ModalControlService,
    private gritApiService : GritApiService,
    private popupService : BsModalService
    ) {
     }



  getPerformanceDefaultValues(): void{
    if(!this.performanceDTOModel.isSingleLevel){
      this.performanceDTOModel.altitudeInterval = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementFT;
      this.performanceDTOModel.altitudeIntervalMeters = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementM;
      this.performanceDTO.altitudeInterval = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrement;
      this.performanceDTOModel.maxAltitude = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeFT;
      this.performanceDTOModel.maxAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeM;
      this.performanceDTO.maxAltitude = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitude;
      this.performanceDTOModel.minAltitude = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeFT;
      this.performanceDTOModel.minAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeM;
      this.performanceDTO.minAltitude = this.configurationService.currentConfiguration.defaultAltitudes.minAltitude;
      this.performanceDTOModel.isAvailablePairs = this.configurationService.currentConfiguration.rnav.availablePairs;
      this.performanceDTOModel.isNSE = this.configurationService.currentConfiguration.rnav.nse;
      this.performanceDTOModel.isRedundancy = this.configurationService.currentConfiguration.rnav.redundancy;
      this.performanceDTOModel.isSubtendedAngles = this.configurationService.currentConfiguration.rnav.subtendedAngle;
    }
    else{
      this.performanceDTOModel.flightLevel = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT;
      this.performanceDTOModel.flightLevelMeters = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeM;
    }
  }

  getCoverageDefaultAltitudes(): void{
    if(!this.coverageDTOModal.isSingleLevel){
      this.coverageDTOModal.altitudeInterval = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementFT;
      this.coverageDTOModal.altitudeIntervalMeters = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementM;
      this.coverageDTO.altitudeInterval = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrement;
      this.coverageDTOModal.maxAltitude = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeFT;
      this.coverageDTOModal.maxAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeM;
      this.coverageDTO.maxAltitude = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitude;
      this.coverageDTOModal.minAltitude = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeFT;
      this.coverageDTOModal.minAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeM;
      this.coverageDTO.minAltitude = this.configurationService.currentConfiguration.defaultAltitudes.minAltitude;
    }
    else{
      this.coverageDTOModal.singleAltitude = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT;
      this.coverageDTOModal.singleAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeM;
    }
  }

  getCoverageAssessmentToolDefaultAltitudes(): void{
      this.coverageAssessmentDTOModal.altitudeInterval = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementFT;
      this.coverageAssessmentDTOModal.altitudeIntervalMeters = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrementM;
      this.coverageDTO.altitudeInterval = this.configurationService.currentConfiguration.defaultAltitudes.altitudeIncrement;
      this.coverageAssessmentDTOModal.maxAltitude = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeFT;
      this.coverageAssessmentDTOModal.maxAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeM;
      this.coverageDTO.maxAltitude = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitude;
      this.coverageAssessmentDTOModal.minAltitude = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeFT;
      this.coverageAssessmentDTOModal.minAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.minAltitudeM;
      this.coverageDTO.minAltitude = this.configurationService.currentConfiguration.defaultAltitudes.minAltitude;
      this.coverageAssessmentDTOModal.singleAltitude = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT;
      this.coverageAssessmentDTOModal.singleAltitudeMeters = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeM;
      this.coverageAssessmentDTOModal.altitudeAboveGround = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT;
      this.coverageAssessmentDTOModal.altitudeAboveGroundMeters = this.configurationService.currentConfiguration.defaultAltitudes.singleLevelAltitudeM;
  }

  coverageAssessmentToolCalculationInitialization(){
    const coverageDTO = cloneDeep(this.coverageDTO);
    const coverageAssessmentDTOModal = cloneDeep(this.coverageAssessmentDTOModal);
    coverageDTO.isCoverageAssessmentTool = true;
    coverageDTO.propagationType = Number(coverageAssessmentDTOModal.propagationType);

    coverageDTO.rangeLimitation = coverageAssessmentDTOModal.rangeLimitation;
    if(coverageAssessmentDTOModal.isSingleLevel){
      coverageDTO.minAltitude = coverageAssessmentDTOModal.singleAltitude / 100;
      coverageDTO.maxAltitude = coverageAssessmentDTOModal.singleAltitude / 100;
      coverageDTO.altitudeInterval = 0;
      coverageDTO.name = coverageAssessmentDTOModal.calculationName;
    }
    else{
      coverageDTO.minAltitude = coverageAssessmentDTOModal.minAltitude / 100;
      coverageDTO.maxAltitude = coverageAssessmentDTOModal.maxAltitude / 100;
      coverageDTO.altitudeInterval=coverageAssessmentDTOModal.altitudeInterval / 100;
      coverageDTO.name = coverageAssessmentDTOModal.calculationName;
    }

    if (coverageAssessmentDTOModal.rangeLimitation == RangeLimitation.FSPL) {
      coverageDTO.useFSPL = true;
    } else {
      coverageDTO.useFSPL = false;
    }

    if (coverageAssessmentDTOModal.propagationType == PropagationType.Diffraction60S
        || coverageAssessmentDTOModal.propagationType == PropagationType.DiffractionKEM) {
          coverageDTO.useFSPL = false;
    }

    if (coverageAssessmentDTOModal.useAltitudeAboveGround){
      coverageDTO.minAltitude = coverageAssessmentDTOModal.altitudeAboveGround / 100;
      coverageDTO.maxAltitude = coverageAssessmentDTOModal.altitudeAboveGround / 100;
    }
    coverageDTO.useAltitudeAboveGround = coverageAssessmentDTOModal.useAltitudeAboveGround;
    coverageDTO.altitudeAboveGround = coverageAssessmentDTOModal.altitudeAboveGround / 100;

    this.mapService.clearSelections();
    coverageDTO.navaids = [];
    coverageDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration, coverageAssessmentDTOModal.coverageAlgorithm, coverageAssessmentDTOModal.rangeLimitation);
    coverageDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);

    const navaidsFeaturesSelected = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    if(!this.validNavaidsForVORCoverage(navaidsFeaturesSelected)){
      return;
    }
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
    pendingCalculation.calculationDTO = coverageDTO;
    pendingCalculation.modalDTO = coverageAssessmentDTOModal;
    pendingCalculation.calculationType = PendingCalculationType.COVERAGE_ASSESSMENT_TOOL;
    this.pointsController.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
  }

  resumeCoverageAssessmentToolCalculation(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight:number[],
    coverageAssessmentDTOModal: coverageAssessmentToolDTOModal, coverageDTO: coverageDTO, navaidsTerrainHeight: number[]){
    let invalidNavaidsList : NavaidModel[] = [];
    let ignoredNavaids : NavaidModel[] = [];
    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length){
      this.modalService.showMesssageModal(
        `Calculation unsuccessful - Terrain Height`,
        `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
      return;
    }
    let numberOfSplices: number = 0;
    for (let i = 0; i<navaidsFeaturesSelected.length; i++) {
      let dtoCalculation : NavaidDTOCalculation = new NavaidDTOCalculation();
      let navaid : NavaidModel = new NavaidModel();
      navaid = this.pointsController.transformFeatureInNavaid(navaidsFeaturesSelected[i]);
      if (navaid.navaidtype == NavaidTypes.DME_ILS || navaid.navaidtype == NavaidTypes.NDB) {
        ignoredNavaids.push(navaid);
        if (navaidsTerrainHeight) {
          navaidsTerrainHeight.splice(i - numberOfSplices, 1);
          numberOfSplices++;
        }
        continue;
      }

      dtoCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(navaidsFeaturesSelected[i]);
      let terrainElevation: number;
      if (navaidsTerrainHeight) {
        terrainElevation = navaidsTerrainHeight[i - numberOfSplices];
      }
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaid.effectiveHeight = navaidsEffectiveHeight[i];
      let dtoCalculationAfterValidation : NavaidDTOCalculation = this.utilsService.defineRangeLimitation(coverageAssessmentDTOModal.rangeLimitation,
          navaidsFeaturesSelected[i].getProperties().arinc424fom,
          dtoCalculation, terrainElevation);

      if (dtoCalculationAfterValidation.id == null) {
        invalidNavaidsList.push(navaid);
      } else if (navaidsTerrainHeight) {
        navaidsTerrainHeight.splice(i - numberOfSplices, 1);
        numberOfSplices++;
      }

      coverageDTO.navaids.push(dtoCalculation);
    }

    // filter navaids
    if (coverageDTO.navaids.length == 0) {
			let message : string = "Only were selected NavAids of type DME (ILS), or NDB.\n";
			message += "Please select other type of NavAids.";
			this.modalService.showMesssageModal("Coverage Calculation", message);
			return null;
		}

    let listOfInvalidNavaidsByAltitude: NavaidDTOCalculation[] = this.utilsService.checkCalculationAltitude(coverageDTO);
    if (listOfInvalidNavaidsByAltitude.length > 0) {
      let navaidsInvalid: string = '';
      listOfInvalidNavaidsByAltitude.forEach(navaid => {
        navaidsInvalid += navaid.id + ", ";
      })
      if ((listOfInvalidNavaidsByAltitude.length == coverageDTO.navaids.length) && coverageAssessmentDTOModal.isSingleLevel) {
        this.modalService.showMesssageModal("No Results", "The performed calculation will not return any result.\n The following NavAids DOC max altitude is bellow minimum simulation altitude: " + navaidsInvalid, "Ok");
      } else {
        this.modalConfirmation.showMesssageConfirmationModal("Results", "The DOC max altitude is bellow some of the simulations altitudes for the following NavAids:\n " + navaidsInvalid + "\n Do you wich to proceed with the calculation?", "Yes", "No",
          () => {
            this.performCoverageAssessmentTool(coverageAssessmentDTOModal.calculationType, coverageDTO, invalidNavaidsList, ignoredNavaids, navaidsTerrainHeight);
          });
      }
      return;
    }

    this.performCoverageAssessmentTool(coverageAssessmentDTOModal.calculationType, coverageDTO, invalidNavaidsList, ignoredNavaids, navaidsTerrainHeight);
  }


  performCoverageAssessmentTool(calculationType: string, coverageDTO: coverageDTO, invalidNavaidsList: NavaidModel[],
    ignoredNavaids: NavaidModel[], navaidsTerrainHeight: number[]) {
    if (invalidNavaidsList.length > 0) {
      if (calculationType == "Coverage") {
        this.validationModalService.showModal(coverageDTO, null, null, invalidNavaidsList, ignoredNavaids, "Coverage", navaidsTerrainHeight);
      } else {
        this.validationModalService.showModal(coverageDTO, null, null, invalidNavaidsList, ignoredNavaids, "Cumulative Coverage", navaidsTerrainHeight);
      }
      return;
    }
    if (calculationType == "Coverage") {
      if (coverageDTO.useFSPL) {
        const bsModalRef: BsModalRef = this.popupService.show(NavaidAntennaModelAssociationComponent);
        bsModalRef.content.coverageDTO = coverageDTO;
        bsModalRef.content.calculationType = calculationType;
        return;
      }
      this.calculationService.calculateCoverage(coverageDTO);
      return;
    }
    this.calculationService.calculateCumulativeCoverage(coverageDTO);
  }

  async coverageCalculationInitialization(){
    const coverageDTO = cloneDeep(this.coverageDTO);
    const coverageDTOModal = cloneDeep(this.coverageDTOModal);

    coverageDTO.isCoverageAssessmentTool = false;
    coverageDTO.isCoverageAssessmentTool = false;
    coverageDTO.supressOverlappingPolygons = true;
    if(coverageDTOModal.isSingleLevel){
      coverageDTO.minAltitude = coverageDTOModal.singleAltitude / 100;
      coverageDTO.maxAltitude = coverageDTOModal.singleAltitude / 100;
      coverageDTO.altitudeInterval = 0;
      coverageDTO.name = coverageDTOModal.calculationName;
    }
    else{
      coverageDTO.minAltitude = coverageDTOModal.minAltitude / 100;
      coverageDTO.maxAltitude = coverageDTOModal.maxAltitude / 100;
      coverageDTO.altitudeInterval=coverageDTOModal.altitudeInterval / 100;
      coverageDTO.name = coverageDTOModal.calculationName;
    }

    this.mapService.clearSelections();
    coverageDTO.navaids = [];
    coverageDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    coverageDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);

    const navaidsFeaturesSelected = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
    pendingCalculation.calculationDTO = coverageDTO;
    pendingCalculation.modalDTO = coverageDTOModal;
    pendingCalculation.calculationType = PendingCalculationType.COVERAGE;
    this.pointsController.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
  }

  resumeCoverageCalculation(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[], coverageDTOModal: coverageDTOModal, coverageDTO: coverageDTO, navaidsTerrainHeight: number[]) {
    let invalidNavaidsList: NavaidModel[] = [];

    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length) {
        this.modalService.showMesssageModal(
        `Calculation unsuccessful - Terrain Height`,
        `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
      return;
    }
    const ignoredNavaids: NavaidModel[] = [];
    let numberOfSplices: number = 0;
    for (let i = 0; i < navaidsFeaturesSelected.length; i++) {
      let dtoCalculation: NavaidDTOCalculation = new NavaidDTOCalculation();
      let navaid = this.pointsController.transformFeatureInNavaid(navaidsFeaturesSelected[i]);
      if(!this.validNavaidTypeForCoverageCalculation(navaid)){
        ignoredNavaids.push(navaid);
        if (navaidsTerrainHeight) {
          navaidsTerrainHeight.splice(i - numberOfSplices, 1);
          numberOfSplices++;
        }
        continue;
      }
      let terrainElevation: number;
      if (navaidsTerrainHeight) {
        terrainElevation = navaidsTerrainHeight[i - numberOfSplices];
      }
      dtoCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(navaidsFeaturesSelected[i]);
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaid.effectiveHeight = navaidsEffectiveHeight[i];
      let dtoCalculationAfterValidation: NavaidDTOCalculation = this.utilsService.defineRangeLimitation(
        this.configurationService.currentConfiguration.calculation.rangeLimitation,
        navaidsFeaturesSelected[i].getProperties().arinc424fom,
        dtoCalculation, terrainElevation
      );

      if (dtoCalculationAfterValidation.id == null) {
          invalidNavaidsList.push(navaid);
      } else if (navaidsTerrainHeight) {
        navaidsTerrainHeight.splice(i - numberOfSplices, 1);
        numberOfSplices++;
      }
      coverageDTO.navaids.push(dtoCalculation);

    }

    const listOfInvalidNavaidsByAltitude: NavaidDTOCalculation[] = this.utilsService.checkCalculationAltitude(coverageDTO);

    if (listOfInvalidNavaidsByAltitude.length > 0) {
      let navaidsInvalid: string = '';
      listOfInvalidNavaidsByAltitude.forEach(navaid => {
        navaidsInvalid += navaid.id + ", ";
      });
      if (listOfInvalidNavaidsByAltitude.length == coverageDTO.navaids.length && coverageDTOModal.isSingleLevel) {
        this.modalService.showMesssageModal(
          "No Results",
          "The performed calculation will not return any result.\n The following NavAids DOC max altitude is below minimum simulation altitude: " +
          navaidsInvalid,
          "Ok"
        );
      } else {
        this.modalConfirmation.showMesssageConfirmationModal(
          "Results",
          "The DOC max altitude is below some of the simulations altitudes for the following NavAids:\n " +
          navaidsInvalid +
          "\n Do you wish to proceed with the calculation?",
          "Yes",
          "No",
          () => {
            if (invalidNavaidsList.length > 0 || ignoredNavaids.length > 0) {
              this.validationModalService.showModal(coverageDTO, null, null, invalidNavaidsList, ignoredNavaids, "Coverage", navaidsTerrainHeight);
              return;
            }
            this.calculationService.calculateCoverage(coverageDTO)
          }
        );
      }
    } else {
      if (invalidNavaidsList.length > 0 || ignoredNavaids.length > 0) {
        this.validationModalService.showModal(coverageDTO, null, null, invalidNavaidsList, ignoredNavaids, "Coverage", navaidsTerrainHeight);
        return;
      }
      this.calculationService.calculateCoverage(coverageDTO);
    }
  }

  overlapCalculationInitialization(navaidsSelected: NavaidModel[]) {
    const coverageDTO = cloneDeep(this.coverageDTO);
    const coverageDTOModal = cloneDeep(this.coverageDTOModal);

    coverageDTO.isCoverageAssessmentTool = false;

    if (coverageDTOModal.isSingleLevel) {
        coverageDTO.minAltitude = coverageDTOModal.singleAltitude / 100;
        coverageDTO.maxAltitude = coverageDTOModal.singleAltitude / 100;
        coverageDTO.altitudeInterval = 0;
        coverageDTO.name = coverageDTOModal.calculationName;
    } else {
        coverageDTO.minAltitude = coverageDTOModal.minAltitude / 100;
        coverageDTO.maxAltitude = coverageDTOModal.maxAltitude / 100;
        coverageDTO.altitudeInterval = coverageDTOModal.altitudeInterval / 100;
        coverageDTO.name = coverageDTOModal.calculationName;
    }

    this.mapService.clearSelections();
    coverageDTO.navaids = [];
    coverageDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    coverageDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsSelected.map(n => this.pointsController.createNavaidFeature(n));
    pendingCalculation.calculationDTO = coverageDTO;
    pendingCalculation.modalDTO = coverageDTOModal;
    pendingCalculation.calculationType = PendingCalculationType.OVERLAP;
    this.pointsController.getNavaidElevationMetersBulkInitialization(navaidsSelected, pendingCalculation);
  }

  resumeOverlapCalculation(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[], coverageDTO: coverageDTO, navaidsTerrainHeight: number[]) {
    let invalidNavaidsList: NavaidModel[] = [];

    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length) {
      this.modalService.showMesssageModal(
      `Calculation unsuccessful - Terrain Height`,
      `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
      return;
    }
    coverageDTO.supressOverlappingPolygons = true;
    let numberOfSplices: number = 0;
    for (let i = 0; i < navaidsFeaturesSelected.length; i++) {
      let dtoCalculation: NavaidDTOCalculation = new NavaidDTOCalculation();
      let navaid: NavaidModel = new NavaidModel();
      navaid = this.pointsController.transformFeatureInNavaid(navaidsFeaturesSelected[i]);
      
      let terrainElevation: number;
      if (navaidsTerrainHeight) {
        terrainElevation = navaidsTerrainHeight[i - numberOfSplices];
      }

      dtoCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(navaidsFeaturesSelected[i]);
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaid.effectiveHeight = navaidsEffectiveHeight[i];
      let dtoCalculationAfterValidation: NavaidDTOCalculation = this.utilsService.defineRangeLimitation(
        "Radio Horizon",
        navaidsFeaturesSelected[i].getProperties().arinc424fom,
        dtoCalculation, terrainElevation
      );

      if (dtoCalculationAfterValidation.id == null) {
        invalidNavaidsList.push(navaid);
      } else if (navaidsTerrainHeight) {
        navaidsTerrainHeight.splice(i - numberOfSplices, 1);
        numberOfSplices++;
      }

      coverageDTO.navaids.push(dtoCalculation);
    }



    for (const nav of coverageDTO.navaids){
      nav.maxOperationalFL = this.configurationService.currentConfiguration.defaultAltitudes.maxAltitudeFT / 100;
      nav.sectorizations = [];
      nav.forceCalculation = true;
    }

    if (invalidNavaidsList.length > 0) {
      this.validationModalService.showModal(coverageDTO, null, null, invalidNavaidsList, null, "Overlap", navaidsTerrainHeight);
      return;
    }


    this.calculationService.calculateOverlap(coverageDTO);
  }
  validNavaidsForVORCoverage(navaidsFeature:Feature[]){
    let hasVOR: boolean = false;
    let hasNonVOR: boolean = false;
    for(let i = 0; i< navaidsFeature.length; i++){
      if(navaidsFeature[i].get('navaidtype') == 'VOR'){
        hasVOR = true;
      }
      else if(navaidsFeature[i].get('navaidtype') !='VOR' && navaidsFeature[i].get('navaidtype') != 'VORTAC' && navaidsFeature[i].get('navaidtype') != 'VOR_DME'){
        hasNonVOR = true;
      }
    }
    if(hasVOR && hasNonVOR){
      this.modalService.showMesssageModal("Cumulative Coverage Calculation", "When calculating VOR coverages only NavAids VOR, VORTAC or VOR/DME can be selected.\n Please check the NavAid selection.");
      return false;
    }
    return true;
  }
  cumulativeCoverageCalculationInitialization() {
    const coverageDTO = cloneDeep(this.coverageDTO);
    const coverageDTOModal = cloneDeep(this.coverageDTOModal);
    coverageDTO.isCoverageAssessmentTool = false;

    if (coverageDTOModal.isSingleLevel) {
        coverageDTO.minAltitude = coverageDTOModal.singleAltitude / 100;
        coverageDTO.maxAltitude = coverageDTOModal.singleAltitude / 100;
        coverageDTO.altitudeInterval = 0;
        coverageDTO.name = coverageDTOModal.calculationName;
    } else {
        coverageDTO.minAltitude = coverageDTOModal.minAltitude / 100;
        coverageDTO.maxAltitude = coverageDTOModal.maxAltitude / 100;
        coverageDTO.altitudeInterval = coverageDTOModal.altitudeInterval / 100;
        coverageDTO.name = coverageDTOModal.calculationName;
    }

    this.mapService.clearSelections();
    coverageDTO.navaids = [];
    coverageDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    coverageDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);

    const navaidsFeaturesSelected = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
    if(!this.validNavaidsForVORCoverage(navaidsFeaturesSelected)){
      return;
    }
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
    pendingCalculation.calculationDTO = coverageDTO;
    pendingCalculation.modalDTO = coverageDTOModal;
    pendingCalculation.calculationType = PendingCalculationType.CUMULATIVE_COVERAGE;
    this.pointsController.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
  }

  resumeCumulativeCoverageCalculation(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[],
      coverageDTOModal: coverageDTOModal, coverageDTO: coverageDTO, navaidsTerrainHeight: number[]) {
    let invalidNavaidsList: NavaidModel[] = [];
    let ignoredNavaids: NavaidModel[] = [];
    coverageDTO.supressOverlappingPolygons = true;
    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length) {
        this.modalService.showMesssageModal(
        `Calculation unsuccessful - Terrain Height`,
        `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
        return;
    }
    let numberOfSplices: number = 0;
    for (let i = 0; i < navaidsFeaturesSelected.length; i++) {
      let dtoCalculation: NavaidDTOCalculation = new NavaidDTOCalculation();
      let navaid: NavaidModel = new NavaidModel();
      navaid = this.pointsController.transformFeatureInNavaid(navaidsFeaturesSelected[i]);
      if ((navaid.navaidtype == 'DME_ILS' && !this.validDMEILSNavaid(navaid)) || navaid.navaidtype == 'NDB') {
        ignoredNavaids.push(navaid);
        if (navaidsTerrainHeight) {
          navaidsTerrainHeight.splice(i - numberOfSplices, 1);
          numberOfSplices++;
        }
        continue;
      }

      let terrainElevation: number;
      if (navaidsTerrainHeight) {
        terrainElevation = navaidsTerrainHeight[i - numberOfSplices];
      }

      dtoCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(navaidsFeaturesSelected[i]);
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaid.effectiveHeight = navaidsEffectiveHeight[i];
      let dtoCalculationAfterValidation: NavaidDTOCalculation = this.utilsService.defineRangeLimitation(
        this.configurationService.currentConfiguration.calculation.rangeLimitation,
        navaidsFeaturesSelected[i].getProperties().arinc424fom,
        dtoCalculation, terrainElevation
      );

      if (dtoCalculationAfterValidation.id == null) {
        invalidNavaidsList.push(navaid);
      } else if (navaidsTerrainHeight) {
        navaidsTerrainHeight.splice(i - numberOfSplices, 1);
        numberOfSplices++;
      }

      coverageDTO.navaids.push(dtoCalculation);
    }

    if(coverageDTO.navaids.length == 0){
      this.modalService.showMesssageModal("Cumulative Coverage Calculation","Only were selected NavAids of type DME (ILS), or NDB.\n Please select other type of NavAids.");
      return;
    }
  
    let listOfInvalidNavaidsByAltitude: NavaidDTOCalculation[] = this.utilsService.checkCalculationAltitude(coverageDTO);

    if (listOfInvalidNavaidsByAltitude.length > 0) {
      let navaidsInvalid: string = '';
      listOfInvalidNavaidsByAltitude.forEach(navaid => {
        navaidsInvalid += navaid.id + ", ";
      })
      if (listOfInvalidNavaidsByAltitude.length == coverageDTO.navaids.length && coverageDTOModal.isSingleLevel) {
        this.modalService.showMesssageModal("No Results", "The performed calculation will not return any result.\n The following NavAids DOC max altitude is below minimum simulation altitude: " + navaidsInvalid, "Ok");
      } else {
        this.modalConfirmation.showMesssageConfirmationModal("Results", "The DOC max altitude is below some of the simulations altitudes for the following NavAids:\n " + navaidsInvalid + "\n Do you wish to proceed with the calculation?", "Yes", "No",
          () => {
            if (invalidNavaidsList.length > 0 || ignoredNavaids.length > 0) {
              this.validationModalService.showModal(coverageDTO, null, null, invalidNavaidsList, ignoredNavaids, "Cumulative Coverage", navaidsTerrainHeight);
              return;
            }
            this.calculationService.calculateCumulativeCoverage(coverageDTO)
          });
      }
    } else {
      if (invalidNavaidsList.length > 0 || ignoredNavaids.length > 0) {
        this.validationModalService.showModal(coverageDTO, null, null, invalidNavaidsList, ignoredNavaids, "Cumulative Coverage", navaidsTerrainHeight);
        return;
      }
      this.calculationService.calculateCumulativeCoverage(coverageDTO);
    }
  }


  performanceCalculationDMEInitialization(){
    const performanceDTO: PerformanceDTO = cloneDeep(this.performanceDTO);
    const performanceDTOModel: PerformanceDTOModel = cloneDeep(this.performanceDTOModel);

    if(performanceDTOModel.isSingleLevel){
      performanceDTO.flightLevel = performanceDTOModel.flightLevel / 100;
      performanceDTO.altitudeInterval = 1;
      performanceDTO.maxAltitude = performanceDTOModel.flightLevel / 100;
      performanceDTO.minAltitude = performanceDTOModel.flightLevel / 100;
      performanceDTO.name = performanceDTOModel.name;

    }
    else{
      performanceDTO.minAltitude = performanceDTOModel.minAltitude / 100;
      performanceDTO.maxAltitude = performanceDTOModel.maxAltitude / 100;
      performanceDTO.altitudeInterval=performanceDTOModel.altitudeInterval / 100;
      performanceDTO.name = performanceDTOModel.name;

    }

    performanceDTO.calculationType = 0;
    performanceDTO.isNSE = performanceDTOModel.isNSE;
    performanceDTO.isAvailablePairs = performanceDTOModel.isAvailablePairs;
    performanceDTO.isRedundancy = performanceDTOModel.isRedundancy;
    performanceDTO.isSubtendedAngles = performanceDTOModel.isSubtendedAngles;
    performanceDTO.supressOverlapingPolygons = performanceDTOModel.isSupressOverlappingPolygons;

    this.mapService.clearSelections();
    performanceDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    performanceDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);
    performanceDTO.navaids = [];

    const navaidsFeaturesSelected = this.pointsController.getSelectedFeaturesOfType(FeatureType.Navaid);
    if (navaidsFeaturesSelected.filter(f => this.validNavaidTypeForPerformanceCalculation(this.pointsController.transformFeatureInNavaid(f))).length < 2) {
      this.modalService.showMesssageModal(
          'Warning',
          'Please select at least 2 RNAV NavAids or DME_ILS omnidirectional navaids with no bias.'
          );
      return;
    }
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
    pendingCalculation.calculationDTO = performanceDTO;
    pendingCalculation.modalDTO = performanceDTOModel;
    pendingCalculation.calculationType = PendingCalculationType.PERFORMANCE_DME;
    this.pointsController.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
  }

  resumePerformanceCalculationDME(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[],
    performanceDTOModel: PerformanceDTOModel, performanceDTO: PerformanceDTO, navaidsTerrainHeight: number[]){

    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length){
      this.modalService.showMesssageModal(
        `Calculation unsuccessful - Terrain Height`,
        `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
      return;
    }

    const invalidNavaidsList : NavaidModel[] = [];
    const ignoredNavaids: NavaidModel[] = [];
    let numberOfSplices: number = 0;
    for (let i = 0; i<navaidsFeaturesSelected.length; i++) {
      const element = navaidsFeaturesSelected[i];
      let dtoCalculation : NavaidDTOCalculation = new NavaidDTOCalculation();
      let navaid = this.pointsController.transformFeatureInNavaid(element);
      if(!this.validNavaidTypeForPerformanceCalculation(navaid)){
        ignoredNavaids.push(navaid);
        if (navaidsTerrainHeight) {
          navaidsTerrainHeight.splice(i - numberOfSplices, 1);
          numberOfSplices++;
        }
        continue;
      }

      let terrainElevation: number;
      if (navaidsTerrainHeight) {
        terrainElevation = navaidsTerrainHeight[i - numberOfSplices];
      }

      dtoCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(element);
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaid.effectiveHeight = navaidsEffectiveHeight[i];
      let dtoCalculationAfterValidation : NavaidDTOCalculation = this.utilsService.defineRangeLimitation(this.configurationService.currentConfiguration.calculation.rangeLimitation,
        element.getProperties().arinc424fom,
        dtoCalculation, terrainElevation);

      if(dtoCalculationAfterValidation.id == null) {
        invalidNavaidsList.push(navaid);
      } else if (navaidsTerrainHeight) {
        navaidsTerrainHeight.splice(i - numberOfSplices, 1);
        numberOfSplices++;
      }
      performanceDTO.navaids.push(dtoCalculation);
    }
    performanceDTO.isDMEDME = true;
    let listOfInvalidNavaidsByAltitude: NavaidDTOCalculation[] = this.utilsService.checkCalculationAltitude(null, performanceDTO);

    if (listOfInvalidNavaidsByAltitude.length > 0) {
      let navaidsInvalid: string = '';
      listOfInvalidNavaidsByAltitude.forEach(navaid => {
        navaidsInvalid += navaid.id + ", ";
      })
      if (listOfInvalidNavaidsByAltitude.length == performanceDTO.navaids.length && performanceDTOModel.isSingleLevel) {
        this.modalService.showMesssageModal("No Results", "The performed calculation will not return any result.\n The following NavAids DOC max altitude is bellow minimum simulation altitude: " + navaidsInvalid, "Ok");
      } else {
        this.modalConfirmation.showMesssageConfirmationModal("Results", "The DOC max altitude is bellow some of the simulations altitudes for the following NavAids:\n " + navaidsInvalid + "\n Do you wich to proceed with the calculation?", "Yes", "No",
          () => {
            if (invalidNavaidsList.length > 0 || ignoredNavaids.length > 0) {
              this.validationModalService.showModal(null, performanceDTO, null, invalidNavaidsList, ignoredNavaids, "Performance", navaidsTerrainHeight);
              return;
            }
            this.calculationService.calculatePerformance(performanceDTO)
          });
      }
    } else {
      if (invalidNavaidsList.length > 0 || ignoredNavaids.length > 0) {
        this.validationModalService.showModal(null, performanceDTO, null, invalidNavaidsList, ignoredNavaids, "Performance", navaidsTerrainHeight);
        return;
      }
      this.calculationService.calculatePerformance(performanceDTO);
    }
  }

  performanceCalculationVORInitialization(){
    const performanceDTO: PerformanceDTO = cloneDeep(this.performanceDTO);
    const performanceDTOModel: PerformanceDTOModel = cloneDeep(this.performanceDTOModel);
    this.performanceDTOModel = new PerformanceDTOModel();

    if (performanceDTOModel.isSingleLevel) {
        performanceDTO.minAltitude = performanceDTOModel.flightLevel / 100;
        performanceDTO.maxAltitude = performanceDTOModel.flightLevel / 100;
        performanceDTO.altitudeInterval = 1;
        performanceDTO.flightLevel = performanceDTOModel.flightLevel / 100;
        performanceDTO.name = performanceDTOModel.name;

    } else {
        performanceDTO.minAltitude = performanceDTOModel.minAltitude / 100;
        performanceDTO.maxAltitude = performanceDTOModel.maxAltitude / 100;
        performanceDTO.altitudeInterval = performanceDTOModel.altitudeInterval / 100;
        performanceDTO.name = performanceDTOModel.name;
    }


    performanceDTO.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    performanceDTO.rnav = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);
    performanceDTO.navaids = [];
    const navaidsFeaturesSelected = this.pointsController.getSelectedFeaturesOfType(FeatureType.Navaid);
    if (navaidsFeaturesSelected.filter(f => f.get("navaidtype") == NavaidTypes.VOR_DME || f.get("navaidtype") == NavaidTypes.VORTAC).length == 0) {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select NavAids of type VOR-DME or VORTAC'
      );
      return;
    }
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
    pendingCalculation.calculationDTO = performanceDTO;
    pendingCalculation.modalDTO = performanceDTOModel;
    pendingCalculation.calculationType = PendingCalculationType.PERFORMANCE_VOR;
    this.pointsController.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
  }

  resumePerformanceCalculationVOR(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[],
    performanceDTOModel: PerformanceDTOModel, performanceDTO: PerformanceDTO, navaidsTerrainHeight: number[]){
    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length){
      this.modalService.showMesssageModal(
        `Calculation unsuccessful - Terrain Height`,
        `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
      return;
    }

    const invalidNavaidsList: NavaidModel[] = [];
    let numberOfSplices: number = 0;
    for (let i = 0; i<navaidsFeaturesSelected.length; i++) {
      const element = navaidsFeaturesSelected[i];
      let dtoCalculation : NavaidDTOCalculation = new NavaidDTOCalculation();
      let navaid = this.pointsController.transformFeatureInNavaid(element);
      if (navaid.navaidtype != NavaidTypes.VOR_DME && navaid.navaidtype != NavaidTypes.VORTAC) {
        if (navaidsTerrainHeight) {
          navaidsTerrainHeight.splice(i - numberOfSplices, 1);
          numberOfSplices++;
        }
        continue;
      }

      let terrainElevation: number;
      if (navaidsTerrainHeight) {
        terrainElevation = navaidsTerrainHeight[i - numberOfSplices];
      }
      
      dtoCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(element);
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaid.effectiveHeight = navaidsEffectiveHeight[i];
      let dtoCalculationAfterValidation : NavaidDTOCalculation = this.utilsService.defineRangeLimitation(this.configurationService.currentConfiguration.calculation.rangeLimitation,
        element.getProperties().arinc424fom,
        dtoCalculation, terrainElevation);

      performanceDTO.navaids.push(dtoCalculation);
      if(dtoCalculationAfterValidation.id == null) {
        invalidNavaidsList.push(navaid);
      } else if (navaidsTerrainHeight) {
        navaidsTerrainHeight.splice(i - numberOfSplices, 1);
        numberOfSplices++;
      }
    }

    performanceDTO.isNSE = performanceDTOModel.isNSE;
    performanceDTO.isAvailablePairs = performanceDTOModel.isAvailablePairs;
    performanceDTO.isRedundancy = performanceDTOModel.isRedundancy;
    performanceDTO.isSubtendedAngles = performanceDTOModel.isSubtendedAngles;
    performanceDTO.supressOverlapingPolygons = performanceDTOModel.isSupressOverlappingPolygons;
    performanceDTO.calculationType = 1;
    performanceDTO.isDMEDME = false;
    //performanceDTO.name = performanceDTOModel.name;
    let listOfInvalidNavaidsByAltitude: NavaidDTOCalculation[] = this.utilsService.checkCalculationAltitude(null, performanceDTO);
    if (listOfInvalidNavaidsByAltitude.length > 0) {
      let navaidsInvalid: string = '';
      listOfInvalidNavaidsByAltitude.forEach(navaid => {
        navaidsInvalid += navaid.id + ", ";
      })
      if (listOfInvalidNavaidsByAltitude.length == performanceDTO.navaids.length && performanceDTOModel.isSingleLevel) {
        this.modalService.showMesssageModal("No Results", "The performed calculation will not return any result.\n The following NavAids DOC max altitude is bellow minimum simulation altitude: " + navaidsInvalid, "Ok");
      } else {
        this.modalConfirmation.showMesssageConfirmationModal("Results", "The DOC max altitude is bellow some of the simulations altitudes for the following NavAids:\n " + navaidsInvalid + "\n Do you wich to proceed with the calculation?", "Yes", "No",
          () => {
            if (invalidNavaidsList.length > 0) {
              this.validationModalService.showModal(null, performanceDTO, null, invalidNavaidsList, null, "Performance", navaidsTerrainHeight);
              return;
            }
            this.calculationService.calculatePerformance(performanceDTO)
          });
      }
    } else {
      if (invalidNavaidsList.length > 0) {
        this.validationModalService.showModal(null, performanceDTO, null, invalidNavaidsList, null, "Performance", navaidsTerrainHeight);
        return;
      }
      this.calculationService.calculatePerformance(performanceDTO);
    }
  }

  getNavaidDTOCalculationArrayInitialization(performanceAnalysisDTO: PerformanceAnalysisDTO, navaidsFeaturesSelected: Feature<Geometry>[], calculationType: PendingCalculationType){
    const pendingCalculation: PendingCalculation = new PendingCalculation();
    pendingCalculation.selectedFeatures = navaidsFeaturesSelected;
    pendingCalculation.calculationDTO = performanceAnalysisDTO;
    pendingCalculation.calculationType = calculationType;
    this.pointsController.getNavaidFeatureElevationMetersBulkInitialization(navaidsFeaturesSelected, pendingCalculation);
  }

  resumeGetNavaidDTOCalculationArray(navaidsFeaturesSelected: Feature<Geometry>[], navaidsEffectiveHeight: number[]){
    if (!navaidsEffectiveHeight || navaidsEffectiveHeight.length != navaidsFeaturesSelected.length){
      this.modalService.showMesssageModal(
        `Calculation unsuccessful - Terrain Height`,
        `The was an error while performing the calculation: Terrain Height. Please confirm all the data and try again.`
      );
      return;
    }
    const navaids: NavaidDTOCalculation[] = [];
    for (let i = 0; i<navaidsFeaturesSelected.length; i++) {
      let dtoCalculation : NavaidDTOCalculation = new NavaidDTOCalculation();
      dtoCalculation = this.pointsController.transformFeatureInNavaidCalculationDTO(navaidsFeaturesSelected[i]);
      dtoCalculation.effectiveHeight = navaidsEffectiveHeight[i];
      navaidsFeaturesSelected[i].set("effectiveHeight", navaidsEffectiveHeight[i]);
      navaids.push(dtoCalculation);
    }
    return navaids;
  }

  private isAllVORKind(navAidList : NavaidModel[]) : boolean {
    navAidList.forEach( nav => {
      let type : string = nav.navaidtype;
			if (!(type == NavaidTypes.VOR || type == NavaidTypes.VOR_DME || type == NavaidTypes.VORTAC)) {
				return false;
			}
    });
    return true;
	}
  validDMEILSNavaid(navaid:NavaidModel){
    return navaid.antennatype == AntennaTypes.OMNIDIRECTIONAL && (navaid.bias == null || navaid.bias == 0)
  }
  validNavaidTypeForPerformanceCalculation(navaid:NavaidModel){
    return NavaidModel.isRNAV(navaid.navaidtype) || (navaid.navaidtype == NavaidTypes.DME_ILS && navaid.antennatype == AntennaTypes.OMNIDIRECTIONAL && (navaid.bias == null || navaid.bias == 0))
  }
  validNavaidTypeForCoverageCalculation(navaid:NavaidModel){
    return (navaid.navaidtype != NavaidTypes.NDB && navaid.navaidtype != NavaidTypes.DME_ILS)
     || (navaid.navaidtype == NavaidTypes.DME_ILS && navaid.antennatype == AntennaTypes.OMNIDIRECTIONAL && (navaid.bias == null || navaid.bias == 0))
  }

  //#region GRIT
  impactAssessmentCalculationInitialization(impactAssessmentDTO : ImpactAssessmentDTO){
    // const coverageDTOModal = cloneDeep(this.coverageDTOModal);

    this.mapService.clearSelections();

    const pendingCalculation: PendingCalculation = new PendingCalculation();
    // pendingCalculation.selectedFeatures = devicesSelected;
    pendingCalculation.calculationDTO = impactAssessmentDTO;
    pendingCalculation.modalDTO = impactAssessmentDTO;
    pendingCalculation.calculationType = PendingCalculationType.IMPACT_ASSESSMENT;

    try{
      const coordinates: Coordinate[] = [];
      const ids: string[] = [];
      for (const device of impactAssessmentDTO.devices){
        coordinates.push([device.longitude, device.latitude]);
        ids.push(device.id);
      }

      this.pointsController.calculateTerrainHeightAtPointBulk(coordinates, pendingCalculation, ids).subscribe({
        error: error => {
          if (error && error.status == 409) {
            this.modalService.showMesssageModal(
              'Calculation unsuccessful',
              'An active terrain is being uploaded, you cannot perform calculations. Please wait for it to finish.' +
              ' If this is not the case, please refresh the page.'
            );
          }
        }
      });
    }
    catch (error){
      console.log("Error performing Calculation: Could not get Elevation");
      throw error;
    }
  }

  resumeImpactAssessmentCalculation(impactAssessmentDTO : ImpactAssessmentDTO, heights: number[]){
    impactAssessmentDTO.devices.forEach((device, index) => {
      device.effectiveHeight = heights[index];
    })

    this.gritApiService.calculateImpactAssessment(impactAssessmentDTO);
  }
  //endregion GRIT
}
